<template lang="pug">
    div.frequency
        div Frequency
        div.mx-1 {{ ` ${frequency}s ` }}
        div
            v-btn(
                color="primary"
                @click="refreshAction(true)"
            ) Refresh
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            frequency: VueTypes.number.def(0),
            refreshAction: VueTypes.func.def(() => {}),
        },
        data() {
            return {
                intervalAction: null,
            };
        },
        watch: {
            frequency(val) {
                if (!val || this.intervalAction) return;
                this.runCallbackWithInterval();
            },
        },
        created() {
            if (this.frequency) {
                this.runCallbackWithInterval();
            }
        },
        beforeDestroy() {
            // Clear interval
            clearInterval(this.intervalAction);
        },
        methods: {
            /**
             * Run callback function with `frequency` interval
             */
            runCallbackWithInterval() {
                // Set launching callback function with interval
                this.intervalAction = setInterval(
                    this.refreshAction,
                    Math.round(this.frequency * 1000)
                );
            },
        },
    };
</script>

<style lang="stylus" scoped>
    .frequency
        display: flex
        justify-content: flex-end
        align-items: center
</style>
